<template>
  <div class="content">
    <div class="md-layout">
      <div
          class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <p-s-table
                tableHeaderColor="purple"
                v-bind:title="this.supplierDetailsTitle"
                height="175"
                v-bind:subTitle="this.supplierDetailsSubTitle"
                v-bind:data="this.supplierDetails"
                v-bind:dict="this.supplierDetailsDict"
                hasRatings="true"
        ></p-s-table>
      </div>
      <div
          class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50"
      >
        <p-s-table
                tableHeaderColor="green"
                title="Systemartikel"
                height="300"
                v-bind:subTitle="this.articlesSubTitle"
                v-bind:data="this.articles"
                v-bind:dict="this.articlesDict"
        ></p-s-table>
      </div>
      <div
          class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50"
      >
        <p-s-table
                tableHeaderColor="orange"
                title="Bewertungen"
                height="300"
                v-bind:subTitle="this.ratingsSubTitle"
                v-bind:data="this.ratings"
                v-bind:dict="this.ratingsDict"
                hasRatings="true"
        ></p-s-table>
      </div>
    </div>
  </div>
</template>

<script>
import { PSTable } from "@/components";
import store from '@/store/index.js';
import api from "@/api/api";

export default {
  name: "SupplierDetails",
  components: { PSTable },
  data() {
    return {
      supplierName: "",
      name: "",
      supplierDetails: [],
      supplierDetailsDict: [
        { key: 'supplierName', label: 'Lieferant', type: 'string'},
        { key: 'city', label: 'Stadt', type: 'string'},
        { key: 'revenue', label: 'Gesamtumsatz', type: 'price'},
        { key: 'rating', label: 'Bewertung', type: 'rating'}
      ],
      ratings: [],
      ratingsDict: [
        { key: 'author', label: 'Author', type: 'string'},
        { key: 'review', label: 'Bewertung', type: 'string'},
        { key: 'rating', label: '', type: 'rating'}
      ],
      articles: [],
      articlesDict: [
        { key: 'supplierArticleNumber', label: 'Artnr. Lieferant', type: 'string'},
        { key: 'supplierArticleDescription', label: 'Bezeichnung', type: 'string'}
      ],
      actions: [
        {
          action: this.openSupplierDetails,
          icon: "search"
        }
      ]
    }
  },
  created () {
    store.commit("setLoading", true);

    api.getSupplierDetails(this.$route.params.id).then((result) => {
      this.supplierDetails = result.data;
      this.supplierName = result.data[0].supplierName;
      this.name = result.data[0].name;

      api.getSupplierRatings(this.$route.params.id).then((result)=> {
        this.ratings = result.data;

        api.getSupplierItems(this.$route.params.id).then((result)=> {
          this.articles = result.data;

          store.commit("setLoading", false);
        });
      });
    });
  },
  computed: {
    supplierDetailsTitle() {
      return "Lieferantendetails für  " + this.supplierName;
    },
    supplierDetailsSubTitle() {
      return "Ansprechpartner " + this.name;
    },
    ratingsSubTitle() {
      return "insgesamt " + this.ratings.length + " Bewertungen";
    },
    articlesSubTitle() {
      return "insgesamt " + this.articles.length + " Artikel";
    }
  },
};
</script>

<style scoped>

</style>
